import { TransactionStatus } from "@/types/transaction";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TransactionStatusBadgeProps {
  status: TransactionStatus;
  className?: string;
}

export function TransactionStatusBadge({ status, className }: TransactionStatusBadgeProps) {
  const config = {
    completed: {
      label: "Completed",
      variant: "outline" as const,
      className: "border-green-500 text-green-700 dark:text-green-300",
    },
    pending: {
      label: "Pending",
      variant: "secondary" as const,
      className: "",
    },
    overdue: {
      label: "Overdue",
      variant: "destructive" as const,
      className: "",
    },
    cancelled: {
      label: "Cancelled",
      variant: "outline" as const,
      className: "border-gray-500 text-gray-700 dark:text-gray-300",
    },
    void: {
      label: "Void",
      variant: "outline" as const,
      className: "border-red-500 text-red-700 dark:text-red-300",
    },
    draft: {
      label: "Draft",
      variant: "outline" as const,
      className: "",
    },
    partially_paid: {
      label: "Partially Paid",
      variant: "outline" as const,
      className: "border-yellow-500 text-yellow-700 dark:text-yellow-300",
    },
  };

  const { label, variant, className: statusClassName } = config[status];

  return (
    <Badge variant={variant} className={cn(statusClassName, className)}>
      {label}
    </Badge>
  );
}
